import { Component, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FullScreenState } from '../../models/full-screen-state';
import { FullscreenManagerService } from '../../services/fullscreen-manager.service';
import { ITableEventsService } from '../../services/table-events.service';

@Component({
  standalone: false,
  selector: 'app-fullscreen-toggle',
  templateUrl: './fullscreen-toggle.component.html',
  styleUrls: ['./fullscreen-toggle.component.scss'],
})
export class FullscreenToggleComponent implements OnInit {
  // set this when using multiple toggles in the same view
  @Input() hasUnresolvedFlags: boolean = false;
  @Input() fullScreenId: string = '';
  @Input() buttonClass: string = '';
  @Input() configStoreTableName: string = '';
  isFullscreen$: Observable<FullScreenState>;

  constructor(
    private fullscreenManagerService: FullscreenManagerService,
    private tableEventsService: ITableEventsService
  ) {
    // start with a dummy observable to avoid ng changes errors
    // because of the async ngOnInit
    this.isFullscreen$ = of({
      isFullScreen: false,
      fullScreenId: '',
      isDisposing: false,
    });
  }

  async ngOnInit(): Promise<void> {
    this.isFullscreen$ =
      await this.fullscreenManagerService.subscribeToFullScreen(
        this.fullScreenId
      );
    this.isFullscreen$.subscribe(() => {});
  }

  toggle(fullScreenId: string) {
    this.fullscreenManagerService.toggle(fullScreenId);
    const timeToRenderFullScreen = 10;
    setTimeout(() => {
      this.tableEventsService.setColumnsOnFullScreenToggle(
        this.configStoreTableName
      );
    }, timeToRenderFullScreen);
  }
}
